import CloseIcon from '@mui/icons-material/Close'
import { Divider, Drawer, IconButton, List, Typography } from '@mui/material'
import { useMediaQuery, useTheme } from 'contexts/ThemeProvider'
import { useMemo } from 'react'
import { screenSizes } from 'utils/constants'
import { v4 as uuidv4 } from 'uuid'
import logoConnectDark from '../../assets/images/logo-connect-dark.svg'
import logoConnectLight from '../../assets/images/logo-connect-light.svg'
import logoTituloConnectDark from '../../assets/images/logo-texto-connect-dark.svg'
import logoTituloConnectLight from '../../assets/images/logo-texto-connect-light.svg'
import { Menu } from 'components/Header/types'
import {
  Container,
  HeaderMenu,
  UnidadeOrganizacionalBox
} from './MenuLateral.styles'
import { MenuLateralProvider } from './context/MenuLateralProvider/MenuLateralProvider'
import { ItemMenu } from './ItemMenu'
import { ListaItensMenu } from './ListaItensMenu'

export interface MenuLateralProps {
  open: boolean
  onClose: () => void
  tituloPlataforma: string
  itensMenu: Menu[]
}

export function MenuLateral({
  open,
  onClose,
  tituloPlataforma,
  itensMenu
}: MenuLateralProps) {
  const { themeName } = useTheme()

  const telaCelular = useMediaQuery(`(max-width:${screenSizes.TABLET})`)
  const telaTablet = useMediaQuery(`(max-width:${screenSizes.NOTEBOOK})`)

  const logoConnect = useMemo(
    () => (themeName === 'dark' ? logoConnectDark : logoConnectLight),
    [themeName]
  )
  const logoTituloConnect = useMemo(
    () =>
      themeName === 'dark' ? logoTituloConnectDark : logoTituloConnectLight,
    [themeName]
  )

  return (
    <MenuLateralProvider onMenuLateralClose={onClose}>
      <Drawer
        anchor="left"
        open={open}
        onClose={onClose}
        data-testid="menu-drawer"
      >
        <Container>
          <HeaderMenu mobile={telaCelular} tablet={telaTablet}>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
            {tituloPlataforma && !telaCelular ? (
              <UnidadeOrganizacionalBox data-testid="unidade-organizacional">
                <img src={logoConnect} height={24} alt="Logo Connect" />
                <Divider orientation="vertical" />
                <Typography variant="h1">{tituloPlataforma}</Typography>
              </UnidadeOrganizacionalBox>
            ) : (
              <img
                data-testid="logo-titulo-connect"
                src={telaCelular ? logoConnect : logoTituloConnect}
                height={26}
                alt="Logo Connect"
              />
            )}
          </HeaderMenu>
          <List component="div" aria-label="main plataforms">
            {itensMenu.map(item =>
              item.itens ? (
                <ListaItensMenu
                  icone={
                    themeName === 'light' ? item.iconeLight : item.iconeDark
                  }
                  key={item.id}
                  itens={item.itens}
                  nome={item.label}
                  isPersonalizado={item.isPersonalizado}
                />
              ) : (
                <ItemMenu
                  icone={
                    themeName === 'light' ? item.iconeLight : item.iconeDark
                  }
                  key={uuidv4()}
                  nome={item.label}
                  rota={item.rota ? item.rota : ''}
                  isPlatform={item.isPlatform}
                  isPersonalizado={item.isPersonalizado}
                />
              )
            )}
          </List>
        </Container>
      </Drawer>
    </MenuLateralProvider>
  )
}
